import { FiCheckCircle } from "react-icons/fi";
import { IconType } from "react-icons";

interface Step {
  number: number;
  label: string;
  icon: IconType;
}

interface ProgressStepperProps {
  steps: Step[];
  currentStep: number;
  accentColor: string;
  textColor: string;
  backgroundColor?: string;
}

function ProgressStepper({
  steps,
  currentStep,
  accentColor,
  textColor,
  backgroundColor,
}: ProgressStepperProps) {
  return (
    <div className="mt-4">
      <div className="flex items-center justify-between">
        {steps.map((step, index) => {
          const Icon = step.icon;
          return (
            <div key={step.number} className="flex items-center flex-1">
              <div className="flex flex-col items-center flex-1">
                {/* Circle */}
                <div
                  className={`relative z-10 flex h-10 w-10 sm:h-12 sm:w-12 items-center justify-center rounded-full border-2 transition-all ${
                    currentStep >= step.number
                      ? "border-transparent shadow-lg"
                      : "border-gray-300 bg-white dark:border-gray-600 dark:bg-boxdark"
                  }`}
                  style={
                    currentStep >= step.number
                      ? {
                          backgroundColor: backgroundColor || accentColor,
                          color: textColor,
                        }
                      : {}
                  }
                >
                  {currentStep > step.number ? (
                    <FiCheckCircle size={20} />
                  ) : (
                    <Icon
                      size={18}
                      className={
                        currentStep < step.number ? "text-gray-400" : ""
                      }
                    />
                  )}
                </div>
                {/* Label - Hidden on very small screens */}
                <span
                  className={`mt-1.5 text-[10px] sm:text-xs font-medium text-center ${
                    currentStep >= step.number
                      ? "text-black dark:text-white"
                      : "text-gray-400 dark:text-gray-600"
                  }`}
                >
                  {step.label}
                </span>
              </div>

              {/* Line */}
              {index < steps.length - 1 && (
                <div className="flex-1 h-0.5 -mx-1 sm:mx-0 mb-6">
                  <div
                    className={`h-full transition-all ${
                      currentStep > step.number
                        ? "opacity-100"
                        : "bg-gray-300 dark:bg-gray-600"
                    }`}
                    style={
                      currentStep > step.number
                        ? { backgroundColor: backgroundColor || accentColor }
                        : {}
                    }
                  />
                </div>
              )}
            </div>
          );
        })}
      </div>
    </div>
  );
}

export default ProgressStepper;
